import React, { ImgHTMLAttributes } from 'react';

type Props = ImgHTMLAttributes<SVGElement>;

const MarginTrading: React.FC<Props> = ({ className }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.96234 4.35424C7.96234 3.3313 8.79002 2.50304 9.81264 2.50304C10.8358 2.50304 11.6638 3.33101 11.6638 4.35424C11.6638 5.37574 10.8358 6.2046 9.81264 6.2046C8.79 6.2046 7.96234 5.37545 7.96234 4.35424ZM9.81264 3.78504C9.4986 3.78504 9.2443 4.03876 9.2443 4.35424C9.2443 4.66802 9.49862 4.9226 9.81264 4.9226C10.1278 4.9226 10.3818 4.66772 10.3818 4.35424C10.3818 4.03906 10.1278 3.78504 9.81264 3.78504Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.7018 3.03572C17.76 3.38492 17.5241 3.71518 17.1749 3.77338L11.1087 4.78446C10.7595 4.84266 10.4292 4.60676 10.371 4.25756C10.3128 3.90836 10.5487 3.5781 10.8979 3.5199L16.9642 2.50882C17.3134 2.45062 17.6436 2.68652 17.7018 3.03572ZM9.25451 4.44678C9.31271 4.79598 9.07681 5.12624 8.72763 5.18444L2.66133 6.19552C2.31215 6.25372 1.98189 6.01782 1.9237 5.66862C1.8655 5.31942 2.10139 4.98916 2.45058 4.93096L8.51687 3.91988C8.86606 3.86168 9.19631 4.09758 9.25451 4.44678Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.07116 17.0825C3.07116 16.7285 3.35814 16.4415 3.71214 16.4415H15.9147C16.2687 16.4415 16.5557 16.7285 16.5557 17.0825C16.5557 17.4365 16.2687 17.7235 15.9147 17.7235H3.71214C3.35814 17.7235 3.07116 17.4365 3.07116 17.0825Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.81279 4.92349C10.1668 4.92349 10.4538 5.21048 10.4538 5.56449V14.2197H12.3212C12.6752 14.2197 12.9622 14.5067 12.9622 14.8607C12.9622 15.2147 12.6752 15.5017 12.3212 15.5017H7.30445C6.95045 15.5017 6.66347 15.2147 6.66347 14.8607C6.66347 14.5067 6.95045 14.2197 7.30445 14.2197H9.17181V5.56449C9.17181 5.21048 9.45879 4.92349 9.81279 4.92349Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.58681 6.48278C4.83128 6.48222 5.05477 6.62078 5.16301 6.83998L7.46884 11.5099C7.57433 11.7235 7.55262 11.978 7.41247 12.1707C5.84691 14.3232 2.86597 14.2777 1.73897 12.0869C1.64648 11.9071 1.64424 11.6942 1.73292 11.5125L4.01225 6.84261C4.11948 6.62291 4.34234 6.48334 4.58681 6.48278ZM4.5916 8.5783L3.03984 11.7576C3.70465 12.6432 5.11702 12.8052 6.13678 11.7077L4.5916 8.5783Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.3864 4.72309C15.6308 4.72253 15.8543 4.86108 15.9626 5.08029L18.2684 9.75017C18.3739 9.96385 18.3521 10.2184 18.2119 10.4111C16.6466 12.5623 13.6656 12.5183 12.5385 10.3272C12.446 10.1474 12.4438 9.9345 12.5325 9.7528L14.8118 5.08292C14.919 4.86322 15.1419 4.72365 15.3864 4.72309ZM15.3911 6.81861L13.8394 9.99785C14.5041 10.8832 15.9164 11.0449 16.9363 9.94789L15.3911 6.81861Z'
      fill='currentColor'
    />
  </svg>
);

export { MarginTrading };
